const Offer = {
    list: () => 'allOffers',
    create: () => 'create/offer',
    getById: (id) => `getOfferById/${id}`,
    update: (id) => `update/offer/${id}`,
    merchantOfferDetail: (id) => `get/all/offers/business/${id}`,
    merchantOfferLocations: (id) => `allLocations/${id}`,
}
export default Offer
